<template>
  <div>
    <div
      class="text-center d-flex flex-row justify-content-center align-items-center mt-4"
    >
      <div
        class="move-page mr-2"
        :class="page == 0 ? 'move-page-disabled' : ''"
        @click="changePage(0)"
      >
        First
      </div>
      <div
        class="move-page mr-2"
        :class="page == 0 ? 'move-page-disabled' : ''"
        @click="changePage(page - 1)"
      >
        Prev
      </div>
      <div class="page" v-if="page > 0" @click="changePage(page - 1)">
        {{ page }}
      </div>
      <div class="page page-current">{{ page + 1 }}</div>
      <div class="page" v-if="page < totalPages" @click="changePage(page + 1)">
        {{ page + 2 }}
      </div>
      <div
        class="move-page ml-2"
        :class="page >= totalPages ? 'move-page-disabled' : ''"
        @click="changePage(page + 1)"
      >
        Next
      </div>
      <div
        class="move-page ml-2"
        :class="page >= totalPages ? 'move-page-disabled' : ''"
        @click="changePage(totalPages)"
      >
        Last
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomPaginator",
  props: ["total", "page", "perPage"],
  methods: {
    changePage(page) {
      if (page >= 0 && page <= this.totalPages) this.$emit("change-page", page);
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.perPage) - 1;
    }
  }
};
</script>

<style scoped>
.page {
  text-align: center;
  border-radius: 5px;
  border: 1px solid #d8d8d8;
  color: #d8d8d8;
  min-width: 25px;
  height: 25px;
  margin: 0px 3px;
  padding: 0px 3px;
}
.page:hover {
  cursor: pointer;
  background-color: #0091c0;
  border-color: white;
  color: white;
}
.page-current {
  background-color: #0091c0;
  border-color: white;
  color: white;
}
.page-current:hover {
  cursor: default;
}
.move-page {
  color: #0091c0;
}
.move-page:hover {
  cursor: pointer;
}
.move-page-disabled {
  color: #e8e8e8;
}
.move-page-disabled:hover {
  cursor: default;
}
.info {
  font-size: 0.8rem;
  color: #0091c0;
  font-weight: bold;
}
</style>
